import { render } from "./MediaNew.vue?vue&type=template&id=6cf802f2"
import script from "./MediaNew.vue?vue&type=script&lang=js"
export * from "./MediaNew.vue?vue&type=script&lang=js"
script.render = render

export default script